import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import CustomSubcomponentItem from './customSubcomponentItem';
import Dialog from '../../layout/Dialog';
import Panel from '../../layout/Panel';
import { LayoutOrientations } from '../../../globals';
import Spacer from '../../layout/Spacer';
import ListView from '../../listComponent/ListView';

export default function CustomSlideEditor(props)
{
	const currentStepUi = useSelector(state => props.slide && state.uiModule.slideMaster[props.slide] ? state.uiModule.slideMaster[props.slide] : props.step && state.uiModule.ui[props.step] ? state.uiModule.ui[props.step] : null, shallowEqual);

	const drawUsedSubComponents = (() =>
	{
		if (!currentStepUi.customMap) return [];
		let itemsToDraw = [];
		for (let i = 0; i < currentStepUi.customMap.length; i++)
		{
			let item = currentStepUi.customMap[i];
			itemsToDraw.push(<CustomSubcomponentItem id={item.type} key={item.type} index={i} step={props.step} slide={props.slide} item={item} />);
		}
		return itemsToDraw;
	})();

	const drawUnusedSubComponents = (() =>
	{
		if (!currentStepUi.disabledComponents) return [];
		let componentsToDraw = [];
		let keys = Object.keys(currentStepUi.disabledComponents);
		for (let i = 0; i < keys.length; i++)
		{
			let key = keys[i];
			let disabledComponent = currentStepUi.disabledComponents[key]
			if (!currentStepUi.customMap || currentStepUi.customMap.length <= 0)
			{
				componentsToDraw.push(<CustomSubcomponentItem id={disabledComponent.type} key={disabledComponent.type} disableDrag={true} step={props.step} slide={props.slide} item={disabledComponent} />);
			}
			else
			{
				let itemExists = false;
				for (let j = 0; j < currentStepUi.customMap.length; j++)
				{
					let item = currentStepUi.customMap[j];
					if (item.type === disabledComponent.type)
					{
						itemExists = true;
						break;
					}
				}
				if (!itemExists)
					componentsToDraw.push(<CustomSubcomponentItem id={disabledComponent.type} key={disabledComponent.type} disableDrag={true} step={props.step} slide={props.slide} item={disabledComponent} />);
			}
		}
		return componentsToDraw;
	})();

	const drawAdvancedMode = (() =>
	{
		return (
			<Panel style={{ outline: 'solid 2px black' }}>
				<Panel orientation={LayoutOrientations.Horizontal} style={{ maxHeight: '25px', minHeight: '25px' }}>
					<Panel>
						Edit and Add Components to the Template
					</Panel>
					<Spacer size={{ x: "10px" }} />
					<Panel style={{ minWidth: '50%', maxWidth: '50%' }}>
						Sort or Remove Components from the Template
					</Panel>
				</Panel>
				<Panel orientation={LayoutOrientations.Horizontal}>
					<Panel style={{ outline: 'solid 1px black' }}>
						<ListView style={{ maxHeight: '355px' }}>
							{drawUnusedSubComponents}
						</ListView>
					</Panel>
					<Spacer size={{ x: "10px" }} />
					<Panel style={{ minWidth: '50%', maxWidth: '50%', outline: 'solid 1px black' }}>
						<Panel>
							<ListView style={{ maxHeight: '355px' }}>
								{drawUsedSubComponents}
							</ListView>
						</Panel>
					</Panel>
				</Panel>
			</Panel>
		);
	})();

	function onSD()
	{
		if (props.onShutdown)
		{
			props.onShutdown();
		}
	}

	return (
		<Dialog
			title={"Edit Custom Template"}
			className={"slideMasterDialogRoot"}
			contentStyle={{ overflow: 'hidden' }}
			data-name={"slidemaster-custom-slide-root"}
			actions={[
				{
					label: "Close",
				}
			]}
			onShutdown={onSD}
		>
			<Panel style={{ maxHeight: '100%', height: '100%' }}>
				<Panel>
					{drawAdvancedMode}
				</Panel>
				{/* <button onClick={()=>{
                    console.log(currentStepUi)
                }}>YOLO2222</button> */}
			</Panel>
		</Dialog>
	);
}
